import { Phone, Mail, Facebook, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-400 py-12 px-4 sm:px-6 lg:px-8 border-t border-gray-800">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="mb-4">
              <img
                src="/quick-close-png4.png"
                alt="Quick Close Home Offers"
                className="h-20 w-auto"
              />
            </div>
            <p className="text-sm">Helping homeowners sell with confidence.</p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <div className="space-y-2 text-sm">
              <Link to="/" className="block hover:text-blue-400 transition-colors">
                Home
              </Link>
              <Link to="/about" className="block hover:text-blue-400 transition-colors">
                About Us
              </Link>
              <Link to="/how-it-works" className="block hover:text-blue-400 transition-colors">
                How It Works
              </Link>
              <Link to="/faq" className="block hover:text-blue-400 transition-colors">
                FAQ
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <div className="space-y-2 text-sm">
              <Link to="/comparison" className="block hover:text-blue-400 transition-colors">
                Compare Options
              </Link>
              <Link to="/reviews" className="block hover:text-blue-400 transition-colors">
                Client Reviews
              </Link>
              <Link to="/contact" className="block hover:text-blue-400 transition-colors">
                Contact Us
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <div className="space-y-3 text-sm">
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-blue-400" />
                <span>412-284-6681</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-blue-400" />
                <span>quickclosehomeoffers@gmail.com</span>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-800">
              <h4 className="text-white font-semibold mb-3 text-sm">Find Us On</h4>
              <div className="flex items-center gap-4">
                <a
                  href="https://www.facebook.com/share/17mAhipAog/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-gray-400 hover:text-blue-400 transition-colors text-sm"
                  aria-label="Quick Close Home Offers on Facebook"
                >
                  <Facebook className="w-5 h-5" />
                  <span>Facebook</span>
                </a>
                <a
                  href="https://www.linkedin.com/company/quick-close-home-offers/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-gray-400 hover:text-blue-400 transition-colors text-sm"
                  aria-label="Quick Close Home Offers on LinkedIn"
                >
                  <Linkedin className="w-5 h-5" />
                  <span>LinkedIn</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="grid md:grid-cols-2 gap-4 text-sm">
            <div>
              <p>&copy; 2026 Quick Close Home Offers. All rights reserved.</p>
            </div>
            <div className="md:text-right space-x-4">
              <Link to="/legal" className="hover:text-blue-400 transition-colors">
                Privacy Policy
              </Link>
              <Link to="/legal" className="hover:text-blue-400 transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
          <p className="text-xs mt-4 text-gray-500">
            We are a direct home buyer, not a licensed real estate agent or broker.
          </p>
        </div>
      </div>
    </footer>
  );
}
